import React, { CSSProperties, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Image, message } from "antd";
import WithAuth from "../../hoc/WithAuth";
import {
  useGetOrganizationDetail,
  useGetOrganizationDocuments,
} from "../../api/organization";
import { getStatusColor } from "../../util/statusColor";
import {
  useGetContactPersonByOrgId,
  useUserUpdateStatus,
} from "../../api/users";

const wrapper: CSSProperties = {
  display: "flex",
  width: "100%",
  gap: 10,
  fontSize: 16,
  marginBottom: 20,
  justifyContent: "space-between",
  alignItems: "flex-end",
  borderBottom: "1px solid #E9EDF4",
  paddingBottom: 5,
};
const label: CSSProperties = {
  color: "#128807",
  fontWeight: 500,
  fontSize: 18,
};
const value: CSSProperties = {
  color: "#8590A3",
  fontWeight: 500,
  fontSize: 18,
};

const OrganizationDetailPage = () => {
  const { id } = useParams();

  const { data: organization, refetch: refetchDetail } =
    useGetOrganizationDetail(!isNaN(Number(id)) ? Number(id) : 0);
  const { data: contactPerson, refetch: fetchContactPerson } =
    useGetContactPersonByOrgId(id);
  const { mutateAsync: updateStatus, isPending } = useUserUpdateStatus();
  const { data: documents, refetch } = useGetOrganizationDocuments(id || "");
  const [address, setAddress] = useState<any>();
  const [region, setRegion] = useState<string | undefined>();
  const [city, setCity] = useState<string | undefined>();
  const [kifleKetema, setKifleKetema] = useState<string | undefined>();
  const [woreda, setWoreda] = useState<string | undefined>();
  const [kebele, setKebele] = useState<string | undefined>();
  const [houseNumber, setHouseNumber] = useState<string | undefined>();

  useEffect(() => {
    if (id) {
      refetch();
      refetchDetail();
      fetchContactPerson();
    }
  }, [id]);

  useEffect(() => {
    if (
      organization &&
      organization.data &&
      organization.data.data &&
      organization.data.data.address
    ) {
      const address = JSON.parse(organization.data.data.address);

      setRegion(address.region);
      setCity(address.city);
      setKifleKetema(address.kifleKetema);
      setWoreda(address.woreda);
      setKebele(address.kebele);
      setHouseNumber(address.house_number);
    }
  }, [organization]);

  const changeUserStatus = async (_status: number) => {
    try {
      const result = await updateStatus({
        id: contactPerson?.data.data.id,
        status: _status,
      });
      message.success("Status updated successfully.");
    } catch (err: any) {
      message.error("Operation failed.");
    } finally {
      fetchContactPerson();
    }
  };

  return (
    <div
      className="px-5 md:px-[50px]"
      style={{
        display: "flex",
        flexDirection: "column",
        borderRadius: 8.5,
        marginTop: 25,
        backgroundColor: "white",
      }}
    >
      <div className="flex flex-col md:flex-row md:justify-between">
        <div className="w-full md:w-[48%]">
          <div
            style={{
              fontFamily: "Poppins",
              fontWeight: 700,
              //   width: "500px",
              borderRadius: "8.5px",
              backgroundColor: "white",
              padding: "33px",
              paddingLeft: 0,
              paddingRight: 0,
            }}
          >
            <div
              style={{
                backgroundColor: "#E9EDF4",
                paddingLeft: "15px",
                paddingRight: "15px",
                paddingTop: "15px",
                paddingBottom: "15px",
                borderRadius: "8.5px",
                fontWeight: 500,
                fontSize: "24px",
                marginBottom: "30px",
              }}
            >
              Organization detail
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <div style={wrapper}>
                <div style={label}>Organization name</div>
                <div style={value}>{organization?.data?.data?.name}</div>
              </div>

              <div style={wrapper}>
                <div style={label}>Organization type</div>
                <div style={value}>
                  {organization?.data?.data?.type === "MICRO-FINANCE"
                    ? "BANK"
                    : organization?.data?.data?.type}
                </div>
              </div>

              <div style={wrapper}>
                <div style={label}>Email</div>
                <div style={value}>{organization?.data?.data?.email}</div>
              </div>

              <div style={wrapper}>
                <div style={label}>Phone number</div>
                <div style={value}>{organization?.data?.data?.phoneNo}</div>
              </div>

              <div style={wrapper}>
                <div style={label}>Status</div>
                <div
                  style={{
                    ...value,
                    display: "flex",
                    justifyContent: "center",
                    width: 100,
                    paddingTop: 6,
                    paddingBottom: 6,
                    borderRadius: 8.5,
                    color: getStatusColor(organization?.data?.data?.status!),
                    backgroundColor: `${getStatusColor(
                      organization?.data?.data?.status!,
                    )}44`,
                  }}
                >
                  {organization?.data?.data?.status}
                </div>
              </div>
            </div>
          </div>
          <div className="w-full ">
            <div
              style={{
                fontFamily: "Poppins",
                fontWeight: 700,
                // width: "500px",
                borderRadius: "8.5px",
                backgroundColor: "white",
                padding: "33px",
                paddingLeft: 0,
                paddingRight: 0,
              }}
            >
              <div
                style={{
                  backgroundColor: "#E9EDF4",
                  paddingLeft: "15px",
                  paddingRight: "15px",
                  paddingTop: "15px",
                  paddingBottom: "15px",
                  borderRadius: "8.5px",
                  fontWeight: 500,
                  fontSize: "24px",
                  marginBottom: "30px",
                }}
              >
                Address
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  marginBottom: 20,
                }}
              >
                <div style={wrapper}>
                  <div style={label}>Region</div>
                  <div style={value}>{region}</div>
                </div>

                <div style={wrapper}>
                  <div style={label}>City</div>
                  <div style={value}>{city}</div>
                </div>

                <div style={wrapper}>
                  <div style={label}>Kifle ketema</div>
                  <div style={value}>{kifleKetema}</div>
                </div>

                <div style={wrapper}>
                  <div style={label}>Woreda</div>
                  <div style={value}>{woreda}</div>
                </div>

                <div style={wrapper}>
                  <div style={label}>Kebele</div>
                  <div style={value}>{kebele}</div>
                </div>

                <div style={wrapper}>
                  <div style={label}>House number</div>
                  <div style={value}>{houseNumber}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full md:w-[48%]">
          <div
            style={{
              fontFamily: "Poppins",
              fontWeight: 700,
              //   width: "500px",
              borderRadius: "8.5px",
              backgroundColor: "white",
              padding: "33px",
              paddingLeft: 0,
              paddingRight: 0,
            }}
          >
            <div
              style={{
                backgroundColor: "#E9EDF4",
                paddingLeft: "15px",
                paddingRight: "15px",
                paddingTop: "15px",
                paddingBottom: "15px",
                borderRadius: "8.5px",
                fontWeight: 500,
                fontSize: "24px",
                marginBottom: "30px",
              }}
            >
              Contact Person
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <div style={wrapper}>
                <div style={label}>Full name</div>
                <div style={value}>{contactPerson?.data?.data.fullName}</div>
              </div>

              <div style={wrapper}>
                <div style={label}>Email</div>
                <div style={value}>{contactPerson?.data?.data.email}</div>
              </div>

              <div style={wrapper}>
                <div style={label}>Phone number</div>
                <div style={value}>{contactPerson?.data?.data.phoneNo}</div>
              </div>

              <div style={wrapper}>
                <div style={label}>Role</div>
                <div style={value}>{contactPerson?.data?.data.role}</div>
              </div>

              <div style={wrapper}>
                <div style={label}>Status</div>
                <div
                  className="value"
                  style={{
                    borderRadius: 5,
                    display: "flex",
                    justifyContent: "center",
                    width: 120,
                    paddingTop: 6,
                    paddingBottom: 6,
                    color: `${getStatusColor(
                      contactPerson?.data?.data.isActive === "1"
                        ? "ACTIVE"
                        : "INACTIVE",
                    )}`,
                    backgroundColor: `${getStatusColor(
                      contactPerson?.data?.data.isActive === "1"
                        ? "ACTIVE"
                        : "INACTIVE",
                    )}44`,
                  }}
                >
                  {contactPerson?.data?.data.isActive === "1"
                    ? "ACTIVE"
                    : "INACTIVE"}
                </div>
              </div>

              <div style={wrapper}>
                <div style={label}>Action</div>
                <div
                  onClick={() => {
                    const _status =
                      contactPerson?.data?.data.isActive === "1" ? 0 : 1;
                    changeUserStatus(_status);
                  }}
                  className="value"
                  style={{
                    cursor: "pointer",
                    borderRadius: 5,
                    display: "flex",
                    justifyContent: "center",
                    width: 120,
                    paddingTop: 6,
                    paddingBottom: 6,
                    color: `${getStatusColor(
                      contactPerson?.data?.data.isActive === "1"
                        ? "INACTIVE"
                        : "ACTIVE",
                    )}`,
                    backgroundColor: `${getStatusColor(
                      contactPerson?.data?.data.isActive === "1"
                        ? "INACTIVE"
                        : "ACTIVE",
                    )}44`,
                  }}
                >
                  {isPending
                    ? "Updateing"
                    : contactPerson?.data?.data.isActive === "1"
                      ? "Deactivate"
                      : "Activate"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div
          style={{
            backgroundColor: "#E9EDF4",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "15px",
            paddingBottom: "15px",
            borderRadius: "8.5px",
            fontWeight: 500,
            fontSize: "24px",
            marginBottom: "30px",
          }}
        >
          Legal documents
        </div>
      </div>
      <div className="flex flex-wrap gap-6">
        {documents &&
        documents.data &&
        documents.data.data &&
        documents.data.data.length > 0 ? (
          documents.data.data.map((doc: any) => {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  border: `1px solid transparent`,
                  borderRadius: 4,
                  width: 400,
                  height: "auto",
                  overflow: "hidden",
                }}
              >
                {/* {ext === 'pdf' && <iframe src={doc.document_url} style={{ width: '100%', height: '100%' }} />} */}
                <Image
                  preview={true}
                  width={"100%"}
                  src={`data:image/*;base64,${doc.file}`}
                  style={{ border: `1px solid transparent`, borderRadius: 4 }}
                />
                <div style={{ display: "flex", justifyContent: "center" }}>{`${
                  doc.name
                } ${doc.isBack ? "(Back side)" : ""}`}</div>
              </div>
            );
          })
        ) : (
          <div className="w-full flex justify-center mb-10 text-3xl text-gray-400">
            No documents found yet.
          </div>
        )}
      </div>
    </div>
  );
};

export default WithAuth(OrganizationDetailPage);
